import { render, staticRenderFns } from "./FamilyApp.vue?vue&type=template&id=3f02f1e4&scoped=true&"
import script from "./FamilyApp.vue?vue&type=script&lang=js&"
export * from "./FamilyApp.vue?vue&type=script&lang=js&"
import style0 from "./FamilyApp.vue?vue&type=style&index=0&id=3f02f1e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f02f1e4",
  null
  
)

export default component.exports